module.exports = __webpack_public_path__ + "static/media/la-republica.4f076688.png";